import { REQUEST, FAILURE, SUCCESS, action, createRequestTypes } from 'redux-config/reduxHelpers';

export const GET_BO_CATEGORIES = createRequestTypes('GET_BO_CATEGORIES');
export const getCategories = {
  request: data => action(GET_BO_CATEGORIES[REQUEST], data),
  success: data => action(GET_BO_CATEGORIES[SUCCESS], { data }),
  failure: error => action(GET_BO_CATEGORIES[FAILURE], { error }),
};

export const GET_BO_QUESTIONS = createRequestTypes('GET_BO_QUESTIONS');
export const getQuestions = {
  request: categoryId => action(GET_BO_QUESTIONS[REQUEST], { categoryId }),
  success: data => action(GET_BO_QUESTIONS[SUCCESS], { data }),
  failure: error => action(GET_BO_QUESTIONS[FAILURE], { error }),
};
